module.exports = __webpack_public_path__ + "static/media/tech.292fafe4.svg";